var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules"},[_c('h2',{staticClass:"rules_title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"rules_content"},[_vm._v(" "+_vm._s(_vm.detail)+" ")]),(_vm.is_jump == 1)?_c('div',{staticClass:"rules_button"},[_c('span',{staticClass:"rules_button_text",on:{"click":_vm.handleJump}},[_vm._v(_vm._s(_vm.jump_title))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }